import { format } from 'date-fns';

import { APP_ADVERTISEMENT_CARD, CONTENT_CARD_PAGE_PER_COUNT, QUESTION_CARD_COLOR_CLASS, REFUND_ADVERTISEMENT_CARD } from '@/lib/constants/content-section';
import { ContentCardItem, QuestionContent } from '@/lib/types/content';

export const contentPageConverter = (pageNo: number, newContents: QuestionContent[], lastCardItemCount: number, isHideAds?: boolean): ContentCardItem[] => {
  const newCardItems: ContentCardItem[] = [];
  const lastQuestionItemCount = (pageNo - 1) * CONTENT_CARD_PAGE_PER_COUNT;

  for (let index = 0, contentIndex = 0; contentIndex < newContents.length; index++) {
    const currentItemIndex = lastCardItemCount + index;

    if (!isHideAds && currentItemIndex % 5 === 2) {
      const adNumber = Math.floor((currentItemIndex + 3) / 5) - 1;
      const isAppAd = adNumber % 2 === 0;

      if (isAppAd) {
        const appIndex = Math.floor(adNumber / 2) % APP_ADVERTISEMENT_CARD.length;
        const appAd = APP_ADVERTISEMENT_CARD[appIndex];
        if (appAd) newCardItems.push(appAd);
      } else {
        const refundIndex = Math.floor(adNumber / 2) % REFUND_ADVERTISEMENT_CARD.length;
        const refundAd = REFUND_ADVERTISEMENT_CARD[refundIndex];
        if (refundAd) newCardItems.push(refundAd);
      }
    } else {
      const item = newContents[contentIndex];
      const colorClass = QUESTION_CARD_COLOR_CLASS[(lastQuestionItemCount + contentIndex) % QUESTION_CARD_COLOR_CLASS.length];

      if (!item || !colorClass) break;
      newCardItems.push({
        id: item.id,
        overText: format(item.createdAt, 'yyyy. M. d.'),
        overTextColorClass: colorClass.overTextColorClass,
        title: item.question,
        titleColorClass: colorClass.titleColorClass,
        backgroundColorClass: colorClass.backgroundColorClass,
        type: 'question',
        respondentOrganization: item.org,
        respondentName: item.name,
        link: `/contents/${item.id}`
      } as ContentCardItem);
      contentIndex++;
    }
  }

  return newCardItems;
};
